import {
  AutopilotTaskDto,
  TaskCategory,
} from '@urbanx/agx.activities.client'
import { TaskCell } from './Cells/TaskCell'
import { AgencyModel } from '@urbanx/agx.agencies.client'
import TaskAgencyCell from './Cells/TaskAgencyCell'
import TaskCampaignCell from './Cells/TaskCampaignCell'
import TaskAssigneeCell from './Cells/TaskAssigneeCell'
import TaskStatusCell from './Cells/TaskStatusCell'
import TaskDueCell from './Cells/TaskDueCell'
import { AgxSpacer } from '@urbanx/agx.ui-components2'

interface TaskRowProps {
  task: AutopilotTaskDto
  rowIdx: number
  assigneeOptions: any[]
  agencies?: AgencyModel[]
  onAssignTask: (
    assignee?: string,
    campaignId?: string ,
    category?: TaskCategory
  ) => void
  onNavigate: (task: AutopilotTaskDto) => void
}

export const TaskRow = ({
  task,
  rowIdx,
  assigneeOptions,
  agencies = [],
  onAssignTask,
  onNavigate,
}: TaskRowProps) => {
  return (
    <tr onClick={() => onNavigate(task)}>
      <td>
        <TaskCell task={task} index={rowIdx} isNew={!!task.isNew} />
      </td>
      <td>
        <TaskAgencyCell
          task={task}
          agencies={agencies}
          index={rowIdx}
          isNew={!!task.isNew}
        />
      </td>
      <td>
        <TaskCampaignCell
          propertyAddress={task.propertyAddress}
          index={rowIdx}
          isNew={!!task.isNew}
        />
      </td>
      <td onClick={(e) => e.stopPropagation()}>
        <AgxSpacer gap={'none'} direction="vertical" contentAlignment="center">
          <TaskAssigneeCell
            task={task}
            assigneeOptions={assigneeOptions}
            onAssignTask={onAssignTask}
          />
        </AgxSpacer>
      </td>
      <td>
        <TaskStatusCell task={task} />
      </td>
      <td align="right">
        <TaskDueCell task={task} />
      </td>
    </tr>
  )
}
